import { useMemo } from 'react';
import PropTypes from 'prop-types';
import PortalIdParser from 'PortalIdParser';
import { OZ } from 'HubStyleTokens/colors';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UISection from 'UIComponents/section/UISection';
import H4 from 'UIComponents/elements/headings/H4';
import UIIcon from 'UIComponents/icon/UIIcon';
import Small from 'UIComponents/elements/Small';
import UILink from 'UIComponents/link/UILink';
import { callingMarketplaceAppsUrl, callingToolSettings, callingUserPreferencesUrl } from '../../utils/urlUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function RegisterPhoneNumberPopover({
  handleProviderSwitch,
  shouldShowProviderSelectionLink
}) {
  const portalId = useMemo(() => {
    return PortalIdParser.get();
  }, []);
  return /*#__PURE__*/_jsxs(UIFlex, {
    direction: "row",
    className: "p-top-4 p-x-4",
    "data-selenium-test": "register-phone-popover",
    children: [/*#__PURE__*/_jsx(UIIllustration, {
      name: "calling",
      width: 80,
      className: "m-right-6"
    }), /*#__PURE__*/_jsxs(UISection, {
      children: [/*#__PURE__*/_jsx(H4, {
        className: "m-top-2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "callingOnboarding.registerPhoneNumberPopover.title"
        })
      }), /*#__PURE__*/_jsx(UISection, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "callingOnboarding.registerPhoneNumberPopover.message"
        })
      }), /*#__PURE__*/_jsxs(UISection, {
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "callingOnboarding.registerPhoneNumberPopover.bullet1"
        }), /*#__PURE__*/_jsxs(UISection, {
          children: [/*#__PURE__*/_jsxs(Small, {
            className: "m-right-8",
            children: [/*#__PURE__*/_jsx(UIIcon, {
              className: "m-right-2",
              name: "success",
              color: OZ,
              size: "xxs"
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "callingOnboarding.registerPhoneNumberPopover.logOutboundCalls"
            })]
          }), /*#__PURE__*/_jsxs(Small, {
            children: [/*#__PURE__*/_jsx(UIIcon, {
              className: "m-right-2",
              name: "success",
              color: OZ,
              size: "xxs"
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "callingOnboarding.registerPhoneNumberPopover.logInboundCalls"
            })]
          })]
        })]
      }), /*#__PURE__*/_jsxs(UISection, {
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "callingOnboarding.registerPhoneNumberPopover.bullet2"
        }), /*#__PURE__*/_jsx(UISection, {
          children: /*#__PURE__*/_jsxs(Small, {
            children: [/*#__PURE__*/_jsx(UIIcon, {
              className: "m-right-2",
              name: "success",
              color: OZ,
              size: "xxs"
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "callingOnboarding.registerPhoneNumberPopover.logOutboundCalls"
            })]
          })
        })]
      }), /*#__PURE__*/_jsxs(UISection, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          "data-selenium-test": "new-number-btn",
          use: "primary",
          href: callingToolSettings(portalId),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "callingOnboarding.registerPhoneNumberPopover.buttons.newNumber"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          "data-selenium-test": "own-number-btn",
          use: "secondary",
          href: callingUserPreferencesUrl(portalId),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "callingOnboarding.registerPhoneNumberPopover.buttons.ownNumber"
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "m-top-6",
        children: /*#__PURE__*/_jsx(Small, {
          children: shouldShowProviderSelectionLink ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "callOnboardingPopover.link_jsx",
            options: {
              onClick: handleProviderSwitch,
              'data-selenium-test': 'onboarding-popover-link'
            },
            elements: {
              UILink
            }
          }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "callingOnboarding.registerPhoneNumberPopover.callingIntegrations_jsx",
            elements: {
              UILink
            },
            options: {
              href: callingMarketplaceAppsUrl(portalId)
            },
            "data-selenium-test": "calling-integration-link"
          })
        })
      })]
    })]
  });
}
RegisterPhoneNumberPopover.propTypes = {
  handleProviderSwitch: PropTypes.func.isRequired,
  shouldShowProviderSelectionLink: PropTypes.bool.isRequired
};
export default RegisterPhoneNumberPopover;